import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import {
  TSubscriberWaterMeter,
  TWaterMeter,
  TWaterMeterReadingData,
} from "types/dto";

import { BarChart } from "components/Charts/BarChart";
import { TSeries, TXAxis, TYAxis } from "components/Charts/BarChart/type";

type TProps = {
  title?: string;
  data?: TWaterMeterReadingData;
  isLoading?: boolean;
};
export const MeterReadingDataChart = (props: TProps) => {
  const { data, isLoading, title } = props;

  const { t } = useTranslation();

  // const [data, setData] = useState<TWaterMeter>();
  const [isGettingData, setIsGettingData] = useState<boolean>(false);

  const chartData = useMemo(() => {
    const _chartData: {
      series: TSeries[];
      xAxis: TXAxis;
      yAxis: TYAxis;
    } = {
      series: [],
      xAxis: { categories: [] },
      yAxis: { title: { text: "" } },
    };
    if (!data || !data.readingData) {
      return _chartData;
    }
    const seriesData_A = data.readingData.map((item) => {
      return Number(item.reportedUsage.toFixed(2));
    });
    const seriesData_B = data.readingData.map((item) => {
      return Number(item.dayUsage.toFixed(2));
    });
    const xAxisData = data.readingData.map((item) =>
      new Date(item.dt).getTime()
    );

    _chartData.series = [
      // { type: "column", data: seriesData_A, options: {name: t("agrigateUsage")} },
      { type: "column", data: seriesData_B, options: { name: t("dayUsage") } },
    ];
    _chartData.xAxis = { categories: xAxisData };
    _chartData.yAxis = { title: { text: "" } };

    return _chartData;
  }, [data]);
  return (
    <CollapsibleSection
      title={title || t("meterReportedDayByDayDataChart")}
      collapsible={true}
      isLoading={isLoading}
      skeleton="chart"
    >
      <BarChart
        series={chartData.series}
        xAxis={chartData.xAxis}
        yAxis={chartData.yAxis}
      />
    </CollapsibleSection>
  );
};
